import { MapPin, Globe, User, Building2, DollarSign, Sparkles, ChevronDown } from 'lucide-react'
import type { ChatContext } from '../../hooks/useChatContext'

const SCOPE_LABELS: Record<string, string> = {
  'app': 'Application',
  'leads': 'All Leads',
  'lead': 'Lead',
  'csp-customers': 'All Customers',
  'csp-customer': 'Customer',
  'it-budgets': 'IT Budgets',
  'gitlab-features': 'GitLab Features',
  'settings': 'Settings',
}

function ScopeIcon({ scope, className }: { scope: string; className?: string }) {
  switch (scope) {
    case 'app':
      return <Globe className={className} />
    case 'leads':
    case 'lead':
      return <User className={className} />
    case 'csp-customers':
    case 'csp-customer':
      return <Building2 className={className} />
    case 'it-budgets':
      return <DollarSign className={className} />
    case 'gitlab-features':
      return <Sparkles className={className} />
    default:
      return <MapPin className={className} />
  }
}

interface Props {
  context: ChatContext
  onClick?: () => void
}

export function ChatContextBadge({ context, onClick }: Props) {
  const label = SCOPE_LABELS[context.scope] || context.scope
  const text = `${label}${context.entityName ? `: ${context.entityName}` : ''}`

  const baseClasses = 'flex items-center gap-1 px-1.5 py-0.5 bg-primary-50 text-primary-700 rounded text-[11px] font-medium transition-colors'
  const clickableClasses = onClick ? ' hover:bg-primary-100 cursor-pointer' : ''

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={baseClasses + clickableClasses}
        title="Change chat scope"
      >
        <ScopeIcon scope={context.scope} className="w-2.5 h-2.5" />
        <span>{text}</span>
        <ChevronDown className="w-2.5 h-2.5 ml-0.5" />
      </button>
    )
  }

  return (
    <div className={baseClasses}>
      <ScopeIcon scope={context.scope} className="w-2.5 h-2.5" />
      <span>{text}</span>
    </div>
  )
}
